import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/class/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/class/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.class.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveClassAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_CLASS_ASYNC, vo });

            EditService.saveClass(
                vo,
                response => {
                    dispatch(Actions.saveClassSuccess(response));
                },
                error => {
                    dispatch(Actions.saveClassFailure(error));
                }
            );
        };
    },

    saveClassSuccess: data => ({
        type: ActionTypes.SAVE_CLASS_SUCCESS,
        parentType: ActionTypes.SAVE_CLASS_ASYNC,
        data
    }),

    saveClassFailure: error => ({
        type: ActionTypes.SAVE_CLASS_FAILURE,
        parentType: ActionTypes.SAVE_CLASS_ASYNC,
        error
    }),

    createClass: () => ({
        type: ActionTypes.CREATE_CLASS
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    classInfo: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, classInfo: data.classInfo };
};

const createClassReducer = (state) => {
    return { ...state, classInfo: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_CLASS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_CLASS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_CLASS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_CLASS]: createClassReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
